export default "__VITE_ASSET__ByS8DWTi__"